import React, { useEffect, useState } from "react";

//user import
// import AdminPortal from "../../layout";
// import AdminPortal from "../../layout";
import { Route, Routes } from "react-router-dom";
import {
  Toolbar,
  Box,
  Typography,
  Grid,
  Paper,
  useTheme,
  TableContainer,
  TableHead,
  TableRow,
  Table,
  TableBody,
  TableCell,
  Button,
  Menu,
  MenuItem,
  Backdrop,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import { format } from "date-fns";
import {
  AmountDepositedIcon,
  AmountTransferedIcon,
  TotalBillsPayedIcon,
  MyBalanceIcon,
  DotsIcon,
} from "../../Svg";
import { makeStyles } from "@mui/styles";
import ApexCharts from "apexcharts";
import { ApiUrls } from "../../Services/Routes/API";
import { headersPost } from "../../Services/API";
import { MainRoutes } from "../../Services/Routes/App";
import { useNavigate } from "react-router-dom";
import ViewModal from "../../components/ViewModal";
import { height } from "@mui/system";

const Dashboard = (props) => {
  // States
  const [barChart, setBarChart] = useState();
  const [donutChart, setDonutChart] = useState();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");
  const [transactions, setTransactions] = useState([]);
  const [amountDeposit, setAmountDeposit] = useState("");
  const [amountTransfer, setAmountTransfer] = useState("");
  const [balance, setBalance] = useState("");
  const [billPayment, setBillPayment] = useState("");
  const [dataForBarchart, setDataForBarchart] = useState([]);
  const [openView, setOpenView] = useState(false);
  const [transactionRow, setTransactionRow] = useState({});

  // CHARTS
  useEffect(() => {
    document.querySelector("#bar-chart").innerHTML = "";
    const BAR_CHART = new ApexCharts(
      document.querySelector("#bar-chart"),
      barChartData
    );
    setBarChart(BAR_CHART);
  }, [barChartData]);

  useEffect(() => {
    const ch = barChart;

    barChart?.render();
  }, [barChart]);

  useEffect(() => {
    document.querySelector("#donut-chart").innerHTML = "";
    const DONUT_CHART = new ApexCharts(
      document.querySelector("#donut-chart"),
      donutChartData
    );
    setDonutChart(DONUT_CHART);
  }, [donutChartData]);

  useEffect(() => {
    const ch = donutChart;

    donutChart?.render();
  }, [donutChart]);

  // Const

  const theme = useTheme();
  const navigate = useNavigate();

  // Styling CSS
  const useStyles = makeStyles({
    cardHead: {
      lineHeight: theme.spacing(3.1),
      color: theme.palette.text.secondary,
    },
    cardText: {
      lineHeight: theme.spacing(3.1),
      color: theme.palette.text.primary,
      fontWeight: 600,
      marginTop: theme.spacing(1),
    },
    paper: {
      borderRadius: 1,
      padding: theme.spacing(3),
      height: 300,
    },
    typographystyle: {
      marginLeft: 16,
    },
    tableHead: {
      color: theme.palette.grey.A100,
      textAlign: "left",
      fontWeight: 500,
      fontSize: theme.spacing(2),
      lineHeight: theme.spacing(2.1),
      letterSpacing: "0.3px",
    },
    tableData: {
      color: theme.palette.grey.A700,
      align: "left",
    },
    list: {
      overflowY: "auto",
      margin: 0,
      padding: 0,
      listStyle: "none",
      height: "100%",
      "&::-webkit-scrollbar": {
        width: "0em",
      },
      "&::-webkit-scrollbar-track": {
        boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
        webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "rgba(0,0,0,0)",
        outline: "1px solid white",
      },
    },
    muiPaperShadowNone: {
      "& .MuiPaper-root": {
        boxShadow: "0px 3px 4px 0px rgb(30 63 138 / 3%)",
        minWidth: "100px",
      },
    },
  });
  const classes = useStyles();
  // Barchart
  var barChartData = {
    chart: {
      type: "bar",
      height: "400px",
      parentHeightOffset: 50,
    },

    plotOptions: {
      bar: {
        border: "1px solid black",
        borderRadius: 8,
        columnWidth: "50%",
        dataLabels: {
          maxItems: 0,
        },
      },
    },

    dataLabels: {
      enabled: false,
      enabledOnSeries: undefined,
      formatter: function (val, opts) {
        return val;
      },
    },

    series: [
      {
        name: "Amount",
        data: [30, 37, 76, 56, 40, 35, 50, 100, 60, 70, 91, 100],
      },
    ],

    yaxis: [
      {
        max: 150,
        min: 0,
      },
    ],

    fill: {
      colors: [
        function ({ value, seriesIndex, w }) {
          const maxValue = Math.max.apply(null, w?.globals?.series?.[0]);
          if (value === maxValue) {
            return "#00008B";
          } else {
            return "#F3F3F3";
          }
        },
      ],
    },

    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
  };

  // DOnut Chart

  var donutChartData = {
    series: [44, 55, 41, 23, 17],
    labels: [
      "Credit Card",
      "Bank Account",
      "Bank Transfer",
      "Pay Attitude",
      "USSD",
    ],
    dataLabels: {
      style: { fontSize: "9px", fontWeight: 250 },
      // enabled: false,
    },

    chart: {
      type: "donut",
      height: "300px",
      // width: "280px",
    },
    legend: {
      position: "bottom",
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          // chart: {
          //   width: 350,
          // },
        },
      },
    ],
  };

  // console.log(donutChart);
  const headings = [
    "Reference ID",
    "Benificiary",
    "Amount",
    "Time",
    "Status",
    "Actions",
  ];
  const rows = [
    {
      reference_Id: "d3r566",
      benificary: "Limos",
      amount: "NGN 2230",
      time: "3-23-2022",
      status: "sucessfull",
    },
    {
      reference_Id: "d3r566",
      benificary: "Limos",
      amount: "NGN 2230",
      time: "3-23-2022",
      status: "failed",
    },
    {
      reference_Id: "d3r566",
      benificary: "Limos",
      amount: "NGN 2230",
      time: "3-23-2022",
      status: "sucessfull",
    },
    {
      reference_Id: "d3r566",
      benificary: "Limos",
      amount: "NGN 2230",
      time: "3-23-2022",
      status: "reversed",
    },
  ];

  // Dropdown
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // Pick Row

  const updateUserData = (item) => {
    setTransactionRow(item);
    setOpenView(true);
  };
  // console.log(transactionRow);

  // Dashboard API

  const getDashboardData = () => {
    const data = {
      request_type: "dashboard",
    };
    setOpen(true);
    headersPost(ApiUrls.GET_DASHBOARD_DATA, data)
      .then((res) => {
        if (res?.status === 200 && res?.data?.success) {
          setTransactions(res.data?.last_4_transactions);
          setAmountDeposit(res.data?.amount_deposited);
          setAmountTransfer(res.data?.amount_transferred);
          setBillPayment(res.data?.bill_payment);
          setDataForBarchart(res.data?.barChartData);
          setBalance(res.data?.balance);

          setOpen(false);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(MainRoutes?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  useEffect(() => {
    getDashboardData();
  }, []);
  return (
    <>
      {/* <AdminPortal {...props} /> */}
      <Box>
        <Grid container spacing={1} mt={6} alignItems={"stretch"}>
          <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
            <Paper
              elevation={1}
              sx={{
                borderRadius: 1,
                padding: theme.spacing(3),

                height: "60%",
              }}
            >
              <Box display={"flex"}>
                <Box>
                  <AmountDepositedIcon />
                </Box>
                <Box marginLeft={2}>
                  <Typography variant="subtitle2" className={classes.cardHead}>
                    Amount Deposited
                  </Typography>
                  <Typography variant="h5" className={classes.cardText}>
                    {amountDeposit}
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
            <Paper
              elevation={1}
              sx={{
                borderRadius: 1,
                padding: theme.spacing(3),
                height: "60%",
              }}
            >
              <Box display={"flex"}>
                <Box>
                  <AmountTransferedIcon />
                </Box>
                <Box marginLeft={2}>
                  <Typography className={classes.cardHead} variant="subtitle2">
                    Amount Transfered
                  </Typography>
                  <Typography variant="h5" className={classes.cardText}>
                    {amountTransfer}
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
            <Paper
              elevation={1}
              sx={{
                borderRadius: 1,
                padding: theme.spacing(3),
                height: "60%",
              }}
            >
              <Box display={"flex"}>
                <Box>
                  <TotalBillsPayedIcon />
                </Box>
                <Box marginLeft={2}>
                  <Typography variant="subtitle2" className={classes.cardHead}>
                    Total Bills Payed
                  </Typography>
                  <Typography variant="h5" className={classes.cardText}>
                    {billPayment}
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
            <Paper
              elevation={1}
              sx={{
                borderRadius: 1,
                padding: theme.spacing(3),
                height: "60%",
              }}
            >
              <Box display={"flex"}>
                <Box>
                  <MyBalanceIcon />
                </Box>
                <Box marginLeft={2}>
                  <Typography variant="subtitle2" className={classes.cardHead}>
                    My Balance
                  </Typography>
                  <Typography variant="h5" className={classes.cardText}>
                    {balance}
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Grid>
        </Grid>

        <Grid mt={4}>
          <Paper elevation={1}>
            <Box
              padding={2}
              id={"bar-chart"}
              // className={classes.paper}
            ></Box>
          </Paper>
        </Grid>
        <Grid
          container
          mt={2}
          display={"flex"}
          justifyContent={"space-between"}
          spacing={3}
          alignItems={"stretch"}
        >
          <Grid item xs={12} sm={8} md={8}>
            <Paper elevation={1} sx={{ height: "100%" }}>
              <Box p={2}>
                <Typography variant="h6">Recent Transaction</Typography>
              </Box>
              <TableContainer className={classes.list} sx={{ maxHeight: 440 }}>
                <Table
                  sx={{ minWidth: 650 }}
                  aria-label="simple table"
                  stickyHeader
                >
                  <TableHead>
                    <TableRow>
                      {headings?.map((h, index) => {
                        {
                          return (
                            <TableCell
                              sx={{ color: "#C4C4C4", fontWeight: 500 }}
                              className={classes.tableHead}
                              key={`${index}-table-heading-${h}`}
                            >
                              {h}
                            </TableCell>
                          );
                        }
                      })}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {transactions?.map((row, index) => (
                      <TableRow key={`${index}-row.name-${index + 2}`}>
                        <TableCell className={classes.tableData}>
                          {row?.slug}
                        </TableCell>
                        <TableCell className={classes.tableData}>
                          {row?.receiver_name}
                        </TableCell>
                        <TableCell className={classes.tableData}>
                          {row?.amount}
                        </TableCell>
                        <TableCell className={classes.tableData}>
                          {row?.created_at
                            ? format(
                                new Date(row?.created_at),
                                "MM/dd/yyyy hh:mm"
                              )
                            : ""}
                        </TableCell>
                        <TableCell
                          sx={{
                            color:
                              row?.status === "successful"
                                ? theme.palette.success.main
                                : theme.palette.error.main,
                            fontWeight: "500",
                          }}
                          // className={classes.tableData}
                        >
                          {row?.status}
                        </TableCell>
                        <TableCell align="center">
                          <Button
                            id={`basic-button-${row?.id}`}
                            aria-controls={open ? "basic-menu" : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? "true" : undefined}
                            onClick={handleClick}
                            // variant="outlined"
                            // onClick={() => addHandler(row)}
                            sx={{
                              borderRadius: 1,
                              minWidth: 0,
                              backgroundColor: "transparent",
                              padding: 0,
                            }}
                          >
                            <DotsIcon />
                          </Button>
                          <Menu
                            id={`basic-menu-${row?.id}`}
                            anchorEl={anchorEl}
                            open={anchorEl?.id === `basic-button-${row?.id}`}
                            onClose={handleClose}
                            MenuListProps={{
                              "aria-labelledby": "basic-button",
                            }}
                            className={classes.muiPaperShadowNone}
                          >
                            <MenuItem
                              onClick={() => {
                                updateUserData(row);
                              }}
                            >
                              View
                            </MenuItem>

                            <MenuItem onClick={handleClose}>Share</MenuItem>
                            <MenuItem onClick={handleClose}>Delete</MenuItem>
                          </Menu>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <Paper elevation={1} sx={{ height: "100%" }}>
              <Box p={2.4}>
                <Typography variant="h6">Payment Methods</Typography>
              </Box>
              <Box marginBottom={2} id={"donut-chart"}></Box>
            </Paper>
          </Grid>
        </Grid>
      </Box>
      <Backdrop
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          color: theme.palette.primary.main,
        }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={alertIcon}>
          {alertMsg}
        </Alert>
      </Snackbar>
      <ViewModal
        open={openView}
        onClose={() => {
          setOpenView(false);
        }}
        row={transactionRow}
      />
    </>
  );
};

export default Dashboard;
